import React, { useState, useEffect, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { useModal } from 'react-modal-hook'
import { Row, Col } from 'react-bootstrap'
import NeoButton from '../../../components/NeoButton/NeoButton'
import Loading from 'custom/assets/loaders/Loading'
import './beneficiary.css'
import Modal from '../../../components/Modal/Modal'
import LargeModel from '../../../components/Modal/largeModel'
import PlusIcon from 'custom/assets/common-icons/plus.svg'
import BeneIcon from 'custom/assets/common-icons/bene-image.svg'
import LayoutWithAccountCard from '../../Layout/layout-account-card'
import BeneficiaryService from '../../../services/beneficiary.service'
import { useTranslation } from 'react-i18next'
import { BENEFICIARY_VIEW_KEYS, BUTTON_KEYS } from '../../../utils/translation-constants'
import envConfig from 'custom/config/environment'

const tabList = envConfig.BENEFICIARY_TRANSFER_TABS.filter(ele=>!['OWN'].includes(ele))


export default function BeneficiaryView() {
  const history = useHistory()
  const [stage, setStage] = useState(1)
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [internalBeneList, setInternalBeneList] = useState([])
  const [otherBeneList, setOtherBeneList] = useState([])
  const [internationalBeneList, setInternationalBeneList] = useState([])
  const [selectedBeneDetails, setSelectedBeneDetails] = useState({})
  const [searchTerm, setSearchTerm] = useState([])
  const [listOfBen, setListOfBen] = useState()
  const [regionalBeneList, setRegionalBeneList] = useState([])

  const { t } = useTranslation()

  const TABS = {
    INTERNAL: {
      label: t(BENEFICIARY_VIEW_KEYS.WITH_IN_BANK),
      stage: 1,
    },
    DOMESTIC: {
      label: t(BENEFICIARY_VIEW_KEYS.DOMESTIC),
      stage: 2,
    },
    INTERNATIONAL: {
      label: t(BENEFICIARY_VIEW_KEYS.INTERNATIONAL),
      stage: 3,
    },
    REGION: {
      label: t(BENEFICIARY_VIEW_KEYS.REGIONAL),
      stage: 4,
    }
  }


  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6 className='text-center'>{message}</h6>
          <div className='modal-btn-style'>
            <NeoButton
              tabIndex='1'
              mode='newDesign'
              type='button'
              text={t(BUTTON_KEYS.OK)}
              onClick={() => {
                hideModal()
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message],
  )

  const [showBeneView, hideBeneView] = useModal(
    () => (
      <LargeModel>
        <div align='right'>
          {/* <h5>Beneficiary Details</h5> */}
          <i
            className='material-icons'
            onClick={() => {
              hideBeneView()
            }}
            style={{ marginTop: -5, cursor: 'pointer' }}>
            close
          </i>
        </div>
        <div className='row beneficiary-details'>
          <div className='col-2'>
            <img
              style={{
                height: 80,
                width: 80,
                margin: '0 auto',
                objectFit: 'contain',
                display: 'block',
              }}
              src={selectedBeneDetails?.image === null ? BeneIcon : selectedBeneDetails?.image}
            />
          </div>
          <div className='col-10'>
            <div className='row'>
              <div className='col-4'>
                <div className='label'>{t(BENEFICIARY_VIEW_KEYS.BENEFICIARY_NAME)}</div>
                <div className='value'>{selectedBeneDetails?.beneName}</div>
              </div>
              <div className='col-4'>
                <div className='label'>{t(BENEFICIARY_VIEW_KEYS.ACCOUNT_NO)}</div>
                <div className='value'>{selectedBeneDetails?.beneAccNo}</div>
              </div>
              <div className='col-4'>
                <div className='label'>{t(BENEFICIARY_VIEW_KEYS.TRANSFER_LIMIT)}</div>
                <div className='value'>
                  {selectedBeneDetails?.maxTransferLimit} {selectedBeneDetails?.beneCurrency}
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-4'>
                <div className='label'>{t(BENEFICIARY_VIEW_KEYS.BRANCH_CODE)}</div>
                <div className='value'>{selectedBeneDetails?.beneBrn || '-'}</div>
              </div>
              <div className='col-4'>
                <div className='label'>{t(BENEFICIARY_VIEW_KEYS.EMAIL_ID)}</div>
                <div className='value' style={{wordBreak: "break-all"}}>{selectedBeneDetails?.beneEmail || '-'}</div>
              </div>
              <div className='col-4'>
                <div className='label'>{t(BENEFICIARY_VIEW_KEYS.MOBILE_NO)}</div>
                <div className='value'>{selectedBeneDetails?.beneMobileNo || '-'}</div>
              </div>
            </div>

            <div className='row'>
              <div className='col-4'>
                <div className='label'>{t(BENEFICIARY_VIEW_KEYS.SHORT_NAME)}</div>
                <div className='value'>{selectedBeneDetails?.shortName}</div>
              </div>
              <div className='col-4'>
                <div className='label'>{t(BENEFICIARY_VIEW_KEYS.BENEFICIARY_TYPE)}</div>
                <div className='value'>{selectedBeneDetails?.beneType}</div>
              </div>
            </div>
            <div className='d-flex align-items-center'>
              <div className='col-5'>
                <NeoButton
                  tabIndex='1'
                  mode='newDesign'
                  type='button'
                  onClick={() => handleModifyBene()}
                  text={t(BUTTON_KEYS.EDIT_BANEFICIARY)}
                />
              </div>
              <div className='col-5 back-cancel-btn-container'>
              <button tabIndex={'2'} className='back-cancel-btn btn btn-sm new-design-warning-text-color'  onClick={() => handleMakePayment()}>
                {t(BUTTON_KEYS.MAKE_PAYMENT)}
                </button>
              </div>
            </div>
          </div>
        </div>
      </LargeModel>
    ),
    [selectedBeneDetails],
  )

  useEffect(() => {
    fetchBeneficiaries()
  }, [])

  const handleMakePayment = useCallback(() => {
    try {
      console.log(selectedBeneDetails)
      history.push({
        pathname: `/transfers/beneficiary-transfers/${
          selectedBeneDetails?.beneType === 'IAT'
            ? 'internal'
            : selectedBeneDetails?.beneType === 'INBK'
            ? 'internal'
            : selectedBeneDetails?.beneType === 'DDACC'
            ? 'other'
            : selectedBeneDetails?.beneType === 'RTGS'
            ? 'other'
            : selectedBeneDetails?.beneType === 'THIRD_PARTY'
            ? 'other'
            : selectedBeneDetails?.beneType === 'REGION'
            ? 'region'
            : 'international'
        }`,
        state: {
          beneDetails: selectedBeneDetails,
          transferType: '',
        },
      })
    } catch (err) {
      console.error(err)
    }
  }, [selectedBeneDetails])

  const handleModifyBene = useCallback(() => {
    try {
      console.log(selectedBeneDetails)
      history.push({
        pathname: `/transfers/edit-beneficiary/${
          selectedBeneDetails?.beneType === 'IAT'
            ? 'internal'
            : selectedBeneDetails?.beneType === 'INBK'
            ? 'internal'
            : selectedBeneDetails?.beneType === 'DDACC'
            ? 'other'
            : selectedBeneDetails?.beneType === 'RTGS'
            ? 'other'
            : selectedBeneDetails?.beneType === 'THIRD_PARTY'
            ? 'other'
            : selectedBeneDetails?.beneType === 'REGION'
            ? 'regional'
            : 'international'
        }`,
        state: {
          beneDetails: selectedBeneDetails,
          transferType: '',
        },
      })
    } catch (err) {
      console.error(err)
    }
  }, [selectedBeneDetails])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderInternalBene()
      case 2:
        return renderOtherBene()
      case 3:
        return renderInternationalBene()
      case 4:
        return renderRegionalBene()
      default:
        return renderInternalBene()
    }
  }

  const fetchBeneficiaries = useCallback(async () => {
    try {
      setLoading(true)
      const response = await BeneficiaryService.getBeneList()
      if (response.status === 200) {
        setListOfBen(response.data)
        setInternalBeneList(response.data['internalBeneList'])
        setInternationalBeneList(
          response.data['otherBankBeneList'].filter((ele) => ele.beneType === 'INTERNATIONAL'),
        )
        setOtherBeneList(
          response.data['otherBankBeneList'].filter((ele) => ele.beneType === 'THIRD_PARTY'),
        )
        setRegionalBeneList(
          response.data['otherBankBeneList'].filter((ele) => ele.beneType === 'REGION'),
        )
      }
      setLoading(false)
    } catch (err) {
      setLoading(false)
      setMessage(err.data.message)
      //showModal()
    }
  }, [])

  const handleSearchChange = useCallback(
    (e) => {
      setSearchTerm(e.target.value)
      if (stage === 1) {
        if (e.target.value === '') {
          setInternalBeneList(listOfBen?.internalBeneList)
        } else
          setInternalBeneList(
            listOfBen?.internalBeneList.filter((v) => {
              return v.shortName.toLowerCase().includes(e.target.value.toLowerCase())
            }),
          )
      } else if (stage === 2) {
        if (e.target.value === '') {
          setOtherBeneList(
            listOfBen?.otherBankBeneList.filter((ele) => ele.beneType === 'THIRD_PARTY'),
          )
        } else
          setOtherBeneList(
            listOfBen?.otherBankBeneList
              .filter((ele) => ele.beneType === 'THIRD_PARTY')
              .filter((v) => {
                return v.shortName.toLowerCase().includes(e.target.value.toLowerCase())
              }),
          )
      } else if (stage === 3) {
        if (e.target.value === '') {
          setInternationalBeneList(
            listOfBen?.otherBankBeneList.filter((ele) => ele.beneType === 'INTERNATIONAL'),
          )
        } else
          setInternationalBeneList(
            listOfBen?.otherBankBeneList
              .filter((ele) => ele.beneType === 'INTERNATIONAL')
              .filter((v) => {
                return v.shortName.toLowerCase().includes(e.target.value.toLowerCase())
              }),
          )
      }else if (stage === 4) {
        if (e.target.value === '') {
          setRegionalBeneList(
            listOfBen?.otherBankBeneList.filter((ele) => ele.beneType === 'REGION'),
          )
        } else
          setRegionalBeneList(
            listOfBen?.otherBankBeneList
              .filter((ele) => ele.beneType === 'REGION')
              .filter((v) => {
                return v.shortName.toLowerCase().includes(e.target.value.toLowerCase())
              }),
          )
      } 
    },
    [stage, listOfBen],
  )

  useEffect(() => {
    setSearchTerm('')
  }, [stage])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  const handleBeneDetails = useCallback(async (selected) => {
    console.log(selected)
    setSelectedBeneDetails(selected)
    showBeneView()
  }, [])

  function renderInternalBene() {
    return (
      <>
        <Row>
          <Col
            xs={'auto'}
            sm={'auto'}
            md={'auto'}
            onClick={() => history.push('/transfers/add-beneficiary')}
            className='bene-card'>
            <img width={30} height={30} src={PlusIcon} />
            <span style={{ color: 'var(--secondary_1)' }}>{t(BENEFICIARY_VIEW_KEYS.ADD_NEW)}</span>
          </Col>
          {internalBeneList.map((item, index) => (
            <Col
              xs={'auto'}
              sm={'auto'}
              md={'auto'}
              key={index}
              onClick={() => handleBeneDetails(item)}
              className='bene-card'>
              <img
                style={{ height: 30, width: 30, margin: '0 auto', objectFit: 'contain' }}
                src={item.image === null ? BeneIcon : item.image}
              />
              <span>{item.shortName}</span>
            </Col>
          ))}
        </Row>
      </>
    )
  }

  function renderOtherBene() {
    return (
      <>
        <Row>
          <Col
            xs={'auto'}
            sm={'auto'}
            md={'auto'}
            onClick={() => history.push('/transfers/add-beneficiary')}
            className='bene-card'>
            <img width={30} height={30} src={PlusIcon} />
            <span style={{ color: '#var(--secondary_1)' }}>{t(BENEFICIARY_VIEW_KEYS.ADD_NEW)}</span>
          </Col>
          {otherBeneList.map((item, index) => (
            <Col
              xs={'auto'}
              sm={'auto'}
              md={'auto'}
              key={index}
              onClick={() => handleBeneDetails(item)}
              className='bene-card'>
              <img
                style={{ height: 30, width: 30, margin: '0 auto', objectFit: 'contain' }}
                src={item.image === null ? BeneIcon : item.image}
              />
              <span>{item.shortName}</span>
            </Col>
          ))}
        </Row>
      </>
    )
  }

  function renderInternationalBene() {
    return (
      <>
        <Row>
          <Col
            xs={'auto'}
            sm={'auto'}
            md={'auto'}
            onClick={() => history.push('/transfers/add-beneficiary')}
            className='bene-card'>
            <img width={30} height={30} src={PlusIcon} />
            <span style={{ color: 'var(--secondary_1)' }}>{t(BENEFICIARY_VIEW_KEYS.ADD_NEW)}</span>
          </Col>
          {internationalBeneList.map((item, index) => (
            <Col
              xs={'auto'}
              sm={'auto'}
              md={'auto'}
              key={index}
              onClick={() => handleBeneDetails(item)}
              className='bene-card'>
              <img
                style={{ height: 30, width: 30, margin: '0 auto', objectFit: 'contain' }}
                src={item.image === null ? BeneIcon : item.image}
              />
              <span>{item.shortName}</span>
            </Col>
          ))}
        </Row>
      </>
    )
  }
  function renderRegionalBene() {
    return (
      <>
        <Row>
          <Col
            xs={'auto'}
            sm={'auto'}
            md={'auto'}
            onClick={() => history.push('/transfers/add-beneficiary')}
            className='bene-card'>
            <img width={30} height={30} src={PlusIcon} />
            <span style={{ color: 'var(--secondary_1)' }}>{t(BENEFICIARY_VIEW_KEYS.ADD_NEW)}</span>
          </Col>
          {regionalBeneList.map((item, index) => (
            <Col
              xs={'auto'}
              sm={'auto'}
              md={'auto'}
              key={index}
              onClick={() => handleBeneDetails(item)}
              className='bene-card'>
              <img
                style={{ height: 30, width: 30, margin: '0 auto', objectFit: 'contain' }}
                src={item.image === null ? BeneIcon : item.image}
              />
              <span>{item.shortName}</span>
            </Col>
          ))}
        </Row>
      </>
    )
  }
  


  return (
    <LayoutWithAccountCard breadCumKey='BENE_VIEW'>
      <div className='view-beneficiary-list'>
        <h4>{t(BENEFICIARY_VIEW_KEYS.HEADER)}</h4>
        <div className='row bene-navbar d-flex justify-content-between'>
        {tabList.map((option, index) => (
            <div
              key={index}
              className={
                stage === TABS[option]['stage']
                  ? `col-${12 / tabList.length} selected`
                  : `col-${12 / tabList.length}`
              }>
              <span onClick={() => setStage(TABS[option]['stage'])}>{TABS[option]['label']}</span>
            </div>
          ))}
          {/* <div className={stage === 1 ? 'col-4 selected' : 'col-4'}>
            <span onClick={() => setStage(1)}>{t(BENEFICIARY_VIEW_KEYS.WITH_IN_BANK)}</span>
          </div>
          <div className={stage === 2 ? 'col-4 selected' : 'col-4'}>
            <span onClick={() => setStage(2)}>{t(BENEFICIARY_VIEW_KEYS.DOMESTIC)}</span>
          </div>
          <div className={stage === 3 ? 'col-4 selected' : 'col-4'}>
            <span onClick={() => setStage(3)}>{t(BENEFICIARY_VIEW_KEYS.INTERNATIONAL)}</span>
          </div> */}
        </div>
        <div className='mb-3'>
          <input 
            type='search'
            name='search'
            placeholder={t(BENEFICIARY_VIEW_KEYS.SEARCH)}
            className='col-12 search-box'
            onChange={handleSearchChange}
            value={searchTerm}
          />
        </div>
      </div>
      {loading && renderLoading()}
      <div>{!loading && renderSwitch()}</div>
    </LayoutWithAccountCard>
  )
}
